/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {Entity} from '@ion/core/src/types/entities';
import {MemberSearchCriteria} from '@ion/core/src/types/services';
import {SearchFilters} from './types';
import useSearchCriteria, {CriteriaTypes} from './useSearchCriteria';

interface UseMemberSearchCriteriaProps {
  globalGroupId: number;
  viewSubGroups: boolean;
  entity: Entity;
  filters: SearchFilters;
}

/**
 * Re-usable hook that properly memoizes the given variables to return a populated
 * member search request criteria.
 */
export const useMemberSearchCriteria = ({
  globalGroupId,
  viewSubGroups,
  entity,
  filters
}: UseMemberSearchCriteriaProps): MemberSearchCriteria => (
  useSearchCriteria({
    criteriaType : CriteriaTypes.MEMBER_SEARCH,
    globalGroupId,
    entity,
    viewSubGroups,
    filters
  }) as MemberSearchCriteria
);

export default useMemberSearchCriteria;
